import { Text, Stack, Heading } from 'braid-design-system';

export const ListingUpgradeContactHeader = () => (
  <Stack space="small">
    <Heading level="3" component="h2">
      Upgrade to reach more buyers
    </Heading>
    <Text>
      Free listings appear lower in search. Get more buyer exposure with our
      Standard and Accelerate packages.
    </Text>
  </Stack>
);
